import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'video-react/dist/video-react.css';
import { Player } from 'video-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import api from '../../services/api';

import { Container, ButtonPanel, Table } from './styles';

import Button from '../../components/Button';
import TextArea from '../../components/TextArea';
import Loading from '../../components/Loading';

export default class PostDetail extends Component {
  state = {
    advertences: [],
    alert: {},
    confirmations: [],
    loading: true,
    missingPromoters: [],
    post: {},
    showAlert: false,
  };

  statusTranslation = {
    scheduled: 'Agendada',
    published: 'Publicada',
    expired: 'Expirada',
  };

  static propTypes = {
    match: PropTypes.shape().isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    this.loadPost();
    this.loadConfirmations();
  }

  loadPost = async () => {
    try {
      const { data } = await api.get(`posts/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      data.post.status = this.statusTranslation[data.post.status];
      data.post.published_at = data.post.published_at
        ? moment(data.post.published_at).format('DD/MM/YYYY, HH:mm[h]')
        : null;

      this.setState({ post: data.post });
    } catch (err) {
      this.setState({ post: {} });
    }
  };

  loadConfirmations = async () => {
    try {
      const { data } = await api.get('post_promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          post_id: this.props.match.params.id,
        },
      });

      this.setState({
        confirmations: data.confirmations,
        missingPromoters: data.missing_promoters,
      });

      this.setState({ loading: false });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível carregar os divulgadores. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  viewAdvertences = (promoter_id) => {
    this.loadAdvertences(promoter_id);
    this.setState({
      currentPromoterId: promoter_id,
    });
  }

  loadAdvertences = async (promoter_id) => {
    const { post } = this.state;
    try {
      const { data } = await api.get('advertences', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          event_id: post.event_id,
          promoter_id,
        },
      });

      const formated = data.advertences.map(advertence => ({
        ...advertence,
        warned_at: moment(advertence.warned_at).format('DD/MM/YYYY, HH:mm[h]'),
      }));

      this.setState({
        advertences: formated,
      });
    } catch (err) {
      this.setState({
        alert: {
          title: 'Erro',
          type: 'danger',
          messages: ['Não foi possível carregar as advertências. Por favor, atualize a página.'],
          onConfirm: () => this.closeAlert(),
        },
      }, () => {
        this.openAlert();
      });
    }
  }

  addAdvertence = async (e) => {
    e.preventDefault();

    try {
      const { advertenceReason, currentPromoterId, post } = this.state;
      const formData = new FormData();
      if (advertenceReason) {
        formData.append('reason', advertenceReason);
      }
      formData.append('promoter_id', currentPromoterId);
      formData.append('event_id', post.event_id);
      await api.post('advertences', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({
        alert: {
          title: 'Advertência adicionada!',
          type: 'success',
          messages: ['A advertência foi adicionada com sucesso.'],
          onConfirm: () => this.closeAlert(),
        },
      }, () => {
        this.openAlert();
        this.setState({
          advertenceReason: '',
        });
      });

      document.getElementById('closeAdvertenceModal').click();
    } catch (err) {
      this.setState({
        alert: {
          title: 'Erro',
          type: 'danger',
          messages: ['Não foi possível adicionar a advertência. Por favor, atualize a página.'],
          onConfirm: () => this.closeAlert(),
        },
      }, () => {
        this.openAlert();
      });
    }
  };

  deletePost = (id) => {
    this.setState({
      alert: {
        title: 'Atenção',
        type: 'warning',
        messages: ['Tem certeza que deseja deletar esta publicação?'],
        confirmBtnText: 'Deletar',
        confirmBtnBsStyle: 'danger',
        showCancel: true,
        cancelBtnText: 'Não',
        cancelBtnBsStyle: 'info',
        onConfirm: () => this.confirmDeletePost(id),
      },
    }, () => {
      this.openAlert();
    });
  }

  confirmDeletePost = async (id) => {
    const { post } = this.state;
    try {
      await api.delete(`posts/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.props.history.push(`/panel/events/${post.event_id}/posts`);
    } catch (err) {
      this.setState({
        alert: {
          title: 'Erro',
          type: 'danger',
          messages: ['Não foi possível deletar a publicação. Por favor, atualize a página.'],
          onConfirm: () => this.closeAlert(),
        },
      }, () => {
        this.openAlert();
      });
    }
  };

  deleteAdvertence = (id) => {
    this.setState({
      alert: {
        title: 'Atenção',
        type: 'warning',
        messages: ['Tem certeza que deletar esta advertência?'],
        confirmBtnText: 'Deletar',
        confirmBtnBsStyle: 'danger',
        showCancel: true,
        cancelBtnText: 'Não',
        cancelBtnBsStyle: 'info',
        onConfirm: () => this.confirmDeleteAdvertence(id),
      },
    }, () => {
      this.openAlert();
    });
  }

  confirmDeleteAdvertence = async (id) => {
    const { advertences } = this.state;
    try {
      await api.delete(`advertences/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({ advertences: advertences.filter(advertence => advertence.id !== id) });
      this.closeAlert();
    } catch (err) {
      this.setState({
        alert: {
          title: 'Erro',
          type: 'danger',
          messages: ['Não foi possível deletar a advertência. Por favor, atualize a página.'],
          onConfirm: () => this.closeAlert(),
        },
      }, () => {
        this.openAlert();
      });
    }
  };

  checkConfirmation = async (id, decision) => {
    const formData = new FormData();
    formData.append('decision', decision);
    try {
      await api.put(`post_promoters/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.loadConfirmations();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível alterar a conferência. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  render() {
    const {
      advertences,
      advertenceReason,
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      confirmations,
      loading,
      missingPromoters,
      post: {
        content_kind,
        description,
        event,
        image,
        kind,
        published_at,
        status,
        video,
      },
      showAlert,
    } = this.state;
    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <div className="row">
              <div className="col-12">
                <ButtonPanel>
                  <Link
                    to={`/panel/posts/${this.props.match.params.id}/edit`}
                    className="btn btn-success"
                  >
                    Editar post
                  </Link>
                  <Button onClick={() => this.deletePost(this.props.match.params.id)} className="btn btn-danger">Deletar post</Button>
                </ButtonPanel>
              </div>
            </div>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  <div className="card card-big">
                    {content_kind === 'image' ? (
                      <div
                        className="card-image vertical"
                        style={{
                          backgroundImage: `url(${image})`,
                        }}
                      />
                    ) : (
                      <div className="card-video">
                        <Player
                          playsInline
                          src={video}
                          aspectRatio="auto"
                        />
                      </div>
                    )}
                    <div className="card-block">
                      <h4 className="card-title">{event}</h4>
                      <h5 className="sub-title capitalize">{kind}</h5>
                      <p className="card-text">
                        <b>Data de publicação:</b> {published_at}
                      </p>
                      <p className="card-text">
                        <b>Status:</b> <span className="capitalize">{status}</span>
                      </p>
                      {description && (
                        <p className="card-text">
                          <b>Descrição:</b> {description}
                        </p>
                      )}

                      <section>
                        {confirmations.length > 0 || missingPromoters.length > 0 ? (
                          <Fragment>
                            <h5 className="section-title">Divulgadores da publicação</h5>
                            <div className="table-wrapper">
                              <Table className="table">
                                <thead>
                                  <tr>
                                    <th scope="col">Nome</th>
                                    <th scope="col">Instagram</th>
                                    <th scope="col">Confirmado pelo divulgador</th>
                                    <th scope="col">Conferência do produtor</th>
                                    <th scope="col">Produtor que conferiu</th>
                                    <th scope="col">Advertências</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {confirmations.map(confirmation => (
                                    <tr key={confirmation.id}>
                                      <td>{confirmation.promoter.name}</td>
                                      <td>
                                        <a
                                          href={`http://instagram.com/${
                                            confirmation.promoter.instagram_username
                                          }`}
                                          target="blank"
                                        >
                                          @{confirmation.promoter.instagram_username}
                                        </a>
                                      </td>
                                      <td className="green-text">Sim</td>
                                      {confirmation.checked == null ? (
                                        <td>
                                          <button
                                            className="btn btn-danger btn-small"
                                            type="button"
                                            onClick={() => this.checkConfirmation(confirmation.id, 'reject')}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </button>
                                          <button
                                            className="btn btn-success btn-small"
                                            type="button"
                                            onClick={() => this.checkConfirmation(confirmation.id, 'accept')}
                                          >
                                            <FontAwesomeIcon icon={faCheck} />
                                          </button>
                                        </td>
                                      ) : (
                                        <Fragment>
                                          {confirmation.checked ? (
                                            <td className="green-text">Postado corretamente</td>
                                          ) : (
                                            <td className="red-text">Não postado corretamente</td>
                                          )}
                                        </Fragment>
                                      )}
                                      {confirmation.producer_name ? (
                                        <td>{confirmation.producer_name}</td>
                                      ) : (
                                        <td>-</td>
                                      )}
                                      <td>
                                        <button onClick={() => this.viewAdvertences(confirmation.promoter.id)} type="button" className="btn btn-danger btn-small" data-toggle="modal" data-target="#viewAdvertences">
                                          <FontAwesomeIcon icon={faExclamation} />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                  {missingPromoters.map(promoter => (
                                    <tr key={promoter.id}>
                                      <td>{promoter.name}</td>
                                      <td>
                                        <a
                                          href={`http://instagram.com/${promoter.instagram_username}`}
                                          target="blank"
                                        >
                                          @{promoter.instagram_username}
                                        </a>
                                      </td>
                                      <td className="red-text">Não</td>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>
                                        <button onClick={() => this.viewAdvertences(promoter.id)} type="button" className="btn btn-danger btn-small" data-toggle="modal" data-target="#viewAdvertences">
                                          <FontAwesomeIcon icon={faExclamation} />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </Fragment>
                        ) : (
                          <h5 className="section-title">Evento não possui divulgadores ativos.</h5>
                        )}
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal fade" id="viewAdvertences" tabIndex="-1" role="dialog" aria-labelledby="viewAdvertencesLabel" aria-hidden="true">
              <div className="modal-dialog" role="document" style={{ maxWidth: '800px' }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="viewAdvertencesLabel">Advertências</h5>
                    <button id="closeAdvertenceModal" type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <h5>Adicionar advertência:</h5>
                    <form onSubmit={this.addAdvertence}>
                      <div className="input-group">
                        <TextArea
                          onChange={this.handleChange}
                          value={advertenceReason}
                          name="advertenceReason"
                          className="form-control"
                          placeholder="Motivo"
                        />
                        <button className="btn btn-primary send-advertence" type="submit">Enviar</button>
                      </div>
                    </form>
                    <hr />
                    <h5>Advertências existentes:</h5>
                    {advertences.length > 0 ? (
                      <div className="table-wrapper">
                        <Table className="table">
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Advertido por</th>
                              <th>Motivo</th>
                              <th>Excluir advertência</th>
                            </tr>
                          </thead>
                          <tbody>
                            {advertences.map(advertence => (
                              <tr key={advertence.id}>
                                <th scope="row">{advertence.warned_at}</th>
                                <td>{advertence.producer_name}</td>
                                <td>{advertence.reason}</td>
                                <td>
                                  <Button
                                    onClick={() => this.deleteAdvertence(advertence.id)}
                                    className="btn-outline-danger btn-small"
                                  >
                                    Excluir
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <p className="text-center">Divulgador não possui advertências neste evento.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PostDetail/index.js